import PropTypes from 'prop-types';
import '~/js/modules/fend';

export default class LoginForm extends React.Component {
    static propTypes = {
        countries: PropTypes.array,
        handlerAfterLogIn: PropTypes.func,
        isAddItem: PropTypes.bool,
        handlerIsSignUp: PropTypes.func
    };
    constructor() {
        super();
        this.state = {
            emailValue: '',
            maskedEmailValue: ''
        };
    }
    componentDidMount() {
        const { handlerAfterLogIn } = this.props;

        $('.login-form').fend({customBehaviorAfterSuccess: handlerAfterLogIn});
    }
    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
        if (this.props.currentAttributeId !== prevProps.currentAttributeId) {
            console.log('login panel was updated');
        }
    }
    _renderCountriesList = (countries) => countries.map(country => <option key={country.countryId} value={country.countryCode}>{country.country}</option>);

    _maskEmail = (e) => {
        const value = e.target.value;
        const regex = /(.)(.*)(@.*)/gi;
        const newValue = value.replace(regex, '$1***$3');

        this.setState({maskedEmailValue: newValue});
    };
    _handleEmailChange = (e) => this.setState({emailValue: e.target.value, maskedEmailValue: e.target.value});

    _clearMaskedEmailValue = () => {
        this.setState({emailValue: '', maskedEmailValue: ''});
    };

	_changeComponentAndScroll = () => {
        this.props.handlerIsSignUp(true);
        $('html, body').animate({
            scrollTop: $('#dashboard-modal').offset().top
        }, 2000);
    };

    render() {
        const { countries } = this.props;
        const countryList = this._renderCountriesList(countries);

        return(
            <div className="row login-wrapper container-fluid">
                <h3 className="col-xs-12 col-sm-6 col-sm-offset-3 instructions">Please enter the information used to save your wishlist.</h3>
                <div className="col-xs-9 grey-divider" />
                <form className="row login-form" action="/weddings/login/" data-no-redirect="true" >
                    <div className="col-xs-12 col-sm-8 col-sm-offset-2 control-wrapper custom-ddl">
                        <select name="country" id="country" required>
                            <option value="" defaultValue>Country of Residence</option>
                            <option value="US">UNITED STATES</option>
                            <option value="CA">CANADA</option>
                            <option value="GB">UNITED KINGDOM</option>
                            {countryList}
                        </select>
                    </div>
                    <div className="control-wrapper last-control col-xs-12 col-sm-8 col-sm-offset-2">
                        <input type="email" value={this.state.maskedEmailValue} onChange={this._handleEmailChange} onBlur={this._maskEmail} onFocus={this._clearMaskedEmailValue} name="maskedEmail" id="maskedEmail" placeholder="Your Email" required />
                        <input type="hidden" value={this.state.emailValue} name="email" id="email" />
                    </div>
                    <div className="control-wrapper col-xs-12 col-sm-8 col-sm-offset-2">
                        <input type="text" id="lastName" name="lastName" placeholder="Last Name" required />
                    </div>
                    <div className="col-xs-12 col-sm-8 col-sm-offset-2">
                        <button className="form-submit-button">continue</button>
                    </div>
                </form>
				<div className="col-xs-12">
                    <a className="already-wishlist" onClick={this._changeComponentAndScroll}><i className="ic ic-button-arrow-next"/>
                        I don't have a wishlist
                    </a>
                </div>
            </div>
        );
    }
}
